import ChatBot from 'components/ChatBot/ChatBot';
import { FC } from 'react';

const FmvMiner: FC = () => {
  return <ChatBot key="fmv-miner" mode="standalone" />;
};

export default FmvMiner;
